import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap-5';
import { searchContacts } from '../../../helpers/connect_api';

import AsyncSelect from 'react-select/async';
import { debounce, find } from 'lodash';
import { connect } from 'react-redux';

const ownerToSelectOption = owner => (
  { connectedRecordId: owner.contact.id, label: owner.contact.name, connectedRecordType: 'Connect::Contact' }
);
function ContactInput({ activity, owners, onChange }) {
  const connectedRecords = activity.connectedRecordsAttributes.filter(record => !record._destroy);
  const handleContactChange = (values) => {
    onChange((oldActivity) => {
      // On update, we get a list of all values. To determine deletes, mark everything as deleted and then
      // find all matches between the old and new values and mark the matches as not destroyed.

      const connectedRecords = oldActivity.connectedRecordsAttributes.map(cr => ({ ...cr, '_destroy': true }));
      values.forEach((v) => {
        const matchingRecord = find(
          connectedRecords,
          { connectedRecordId: v.connectedRecordId, connectedRecordType: v.connectedRecordType }
        );

        if (matchingRecord) {
          delete matchingRecord._destroy;
        } else {
          connectedRecords.push(v);
        }
      });

      return { ...activity, connectedRecordsAttributes: connectedRecords };
    });
  };

  useEffect(() => {
    if (activity.id) return;
    if (connectedRecords.length > 0) return;

    const primaryOwner = find(owners, ['primary', true]);
    if (!primaryOwner) return;

    handleContactChange([ownerToSelectOption(primaryOwner)]);
  }, [activity.id, owners]);

  const promiseOptions = useCallback(debounce((inputValue, callback) => {
    searchContacts(inputValue).then((results) => {
      const contactsAndCompanies = [...results.contacts.hits, ...results.companies.hits];
      const options = contactsAndCompanies.map(result => (
        { connectedRecordId: result.id, label: result.name, connectedRecordType: result.type }
      ));
      callback(options);
    });
  }, 300), []);

  const defaultOptions = useMemo(() => (owners || []).map(ownerToSelectOption), [owners]);

  return (
    <Form.Group>
      <Form.Label>Contact</Form.Label>
      <AsyncSelect
        cacheOptions
        defaultOptions={defaultOptions}
        getOptionValue={option => option.connectedRecordId}
        isMulti
        loadOptions={promiseOptions}
        value={connectedRecords}
        onChange={handleContactChange}
      />
    </Form.Group>
  );
}

ContactInput.propTypes = {
  activity: PropTypes.object.isRequired,
  owners: PropTypes.arrayOf(PropTypes.shape({
    contact: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  })),
  onChange: PropTypes.func.isRequired
};

export default connect(({ owners }) => ({ owners }), {})(ContactInput);
